export const withAuthRetry = async <T>(run: () => Promise<T>): Promise<T> => {
  try {
    return await run();
  } catch (error) {
    if (error?.code === "unauthenticated") {
      return run();
    }
    throw error;
  }
};
